<!--Do NOT change this file manually, it is being generated by svgicons script.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import ArrowDown from '../../../../assets/svg/ico-arrow-down.svg';
    import ArrowLeftLongSolid from '../../../../assets/svg/ico-arrow-left-long-solid.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import ArrowRight from '../../../../assets/svg/ico-arrow-right.svg';
    import ArrowUp from '../../../../assets/svg/ico-arrow-up.svg';
    import Bookmark from '../../../../assets/svg/ico-bookmark.svg';
    import CalendarAltRegular from '../../../../assets/svg/ico-calendar-alt-regular.svg';
    import Calendars from '../../../../assets/svg/ico-calendars.svg';
    import Cart from '../../../../assets/svg/ico-cart.svg';
    import Chat from '../../../../assets/svg/ico-chat.svg';
    import CheckCircleSolid from '../../../../assets/svg/ico-check-circle-solid.svg';
    import ChevronDownSolid from '../../../../assets/svg/ico-chevron-down-solid.svg';
    import ChevronDown from '../../../../assets/svg/ico-chevron-down.svg';
    import ClearIconGreen from '../../../../assets/svg/ico-clear-icon-green.svg';
    import ClearIconYellow from '../../../../assets/svg/ico-clear-icon-yellow.svg';
    import ClipboardList from '../../../../assets/svg/ico-clipboard-list.svg';
    import CustomerSupport from '../../../../assets/svg/ico-customer-support.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import DoubleArrow from '../../../../assets/svg/ico-double-arrow.svg';
    import EditRegular from '../../../../assets/svg/ico-edit-regular.svg';
    import Edit from '../../../../assets/svg/ico-edit.svg';
    import EmptySet from '../../../../assets/svg/ico-empty-set.svg';
    import Envelope from '../../../../assets/svg/ico-envelope.svg';
    import Envelope2 from '../../../../assets/svg/ico-envelope2.svg';
    import EyeSlash from '../../../../assets/svg/ico-eye-slash.svg';
    import Eye from '../../../../assets/svg/ico-eye.svg';
    import FacebookFBrands from '../../../../assets/svg/ico-facebook-f-brands.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import Hand from '../../../../assets/svg/ico-hand.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import InstagramBrands from '../../../../assets/svg/ico-instagram-brands.svg';
    import Instagram from '../../../../assets/svg/ico-instagram.svg';
    import List from '../../../../assets/svg/ico-list.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import LongArrowLeft from '../../../../assets/svg/ico-long-arrow-left.svg';
    import LongArrowRight from '../../../../assets/svg/ico-long-arrow-right.svg';
    import MapMarkerAlt from '../../../../assets/svg/ico-map-marker-alt.svg';
    import PhoneIcon from '../../../../assets/svg/ico-phone-icon.svg';
    import Phone from '../../../../assets/svg/ico-phone.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import PlusRegular from '../../../../assets/svg/ico-plus-regular.svg';
    import ReplySolid from '../../../../assets/svg/ico-reply-solid.svg';
    import SearchPlus from '../../../../assets/svg/ico-search-plus.svg';
    import Search from '../../../../assets/svg/ico-search.svg';
    import ShippingFastSolid from '../../../../assets/svg/ico-shipping-fast-solid.svg';
    import ShippingFast from '../../../../assets/svg/ico-shipping-fast.svg';
    import SignOut from '../../../../assets/svg/ico-sign-out.svg';
    import Spinner from '../../../../assets/svg/ico-spinner.svg';
    import SuccessIcon from '../../../../assets/svg/ico-success-icon.svg';
    import Tag from '../../../../assets/svg/ico-tag.svg';
    import TelegramPlane from '../../../../assets/svg/ico-telegram-plane.svg';
    import TimesSolid from '../../../../assets/svg/ico-times-solid.svg';
    import TrashSolid from '../../../../assets/svg/ico-trash-solid.svg';
    import Trash from '../../../../assets/svg/ico-trash.svg';
    import TwitterBrands from '../../../../assets/svg/ico-twitter-brands.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import UserAlt from '../../../../assets/svg/ico-user-alt.svg';
    import User from '../../../../assets/svg/ico-user.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            ArrowDown,
            ArrowLeftLongSolid,
            ArrowLeft,
            ArrowRight,
            ArrowUp,
            Bookmark,
            CalendarAltRegular,
            Calendars,
            Cart,
            Chat,
            CheckCircleSolid,
            ChevronDownSolid,
            ChevronDown,
            ClearIconGreen,
            ClearIconYellow,
            ClipboardList,
            CustomerSupport,
            Dog,
            DoubleArrow,
            EditRegular,
            Edit,
            EmptySet,
            Envelope,
            Envelope2,
            EyeSlash,
            Eye,
            FacebookFBrands,
            Facebook,
            Hand,
            Happy,
            InstagramBrands,
            Instagram,
            List,
            Lock,
            LongArrowLeft,
            LongArrowRight,
            MapMarkerAlt,
            PhoneIcon,
            Phone,
            PlusCircle,
            PlusRegular,
            ReplySolid,
            SearchPlus,
            Search,
            ShippingFastSolid,
            ShippingFast,
            SignOut,
            Spinner,
            SuccessIcon,
            Tag,
            TelegramPlane,
            TimesSolid,
            TrashSolid,
            Trash,
            TwitterBrands,
            Twitter,
            UserAlt,
            User,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
